var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolidEnvelopeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 4.5C21.1602 4.5 22 5.33945 22 6.375C22 6.96484 21.7227 7.51953 21.25 7.875L12.75 14.25C12.3047 14.582 11.6953 14.582 11.25 14.25L2.75 7.875C2.27785 7.51953 2 6.96484 2 6.375C2 5.33945 2.83945 4.5 3.875 4.5H20.125ZM10.5 15.25C11.3906 15.918 12.6094 15.918 13.5 15.25L22 8.875V17C22 18.3789 20.8789 19.5 19.5 19.5H4.5C3.11914 19.5 2 18.3789 2 17V8.875L10.5 15.25Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidEnvelopeWhite);
export default __webpack_public_path__ + "static/media/iconSolidEnvelopeWhite.ea2b4baa723e67d2702af5fd48a5d5da.svg";
export { ForwardRef as ReactComponent };